import { Breadcrumb, ToastContainer } from "pepsico-ds";
import { useParams } from "react-router-dom";
import { paths } from "../../routes/paths";
import "./performances.scss";

import { useQuery } from "@apollo/client";
import { useState } from "react";
import PerformanceDetailsContainer from "../../components/performances/PerformanceDetailsContainer";
import { loadEngagementById } from "../../graphql/queries/loadEngagementById";

const PerformanceDetailsPage = () => {
  const { performanceID } = useParams();
  const { data: engagementDetails, loading } = useQuery(loadEngagementById, {
    variables: {
      id: performanceID,
    },
    skip: !performanceID,
    onError: () => {
      setToastData([{ type: "error", text: "Error loading performance details" }]);
    },
  });
  const [toastData, setToastData] = useState(null);

  return (
    <>
      <div className="container">
        <div className="wrap">
          <Breadcrumb
            breadcrumbs={[
              {
                label: "Performances",
                href: `../../${paths.performances_list}`,
              },
              {
                label: "Performances",
                href: `../../${paths.performances_list}`,
              },
              {
                label: "Performance detail",
                href: `../../${paths.performances_list}/${paths.performance_details}/${performanceID}`,
              },
            ]}
            activeIndex={1}
          />
          <PerformanceDetailsContainer
            title="Performance details"
            showFooter={true}
            engagementData={engagementDetails?.loadEngagementById}
            loading={loading}
          />
        </div>
      </div>
      {toastData && (
        <ToastContainer
          className="performances-listing-toast"
          data={toastData}
          removeToast={() => setToastData([])}
          showActionIcon
        />
      )}
    </>
  );
};

export default PerformanceDetailsPage;
